import React from 'react';
import NavBar from 'components/NavBar';
import { useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import navbarItems from 'helpers/navigationOptionsHelper';

const NavBarContainer = ({ className }) => {
  const displayNavBar = useSelector((state) => state.displayNavBar);
  const subscription = useSelector((state) => state.subscription);
  const account = useSelector((state) => state.account);
  const location = useLocation();
  const items = navbarItems(subscription, account, location)

  return displayNavBar ? <NavBar items={items} /> : null;
};

NavBarContainer.displayName = 'NavBarContainer';

export default NavBarContainer;
